module.exports = __webpack_public_path__ + "img/css.c3ce0c15.png";